import * as React from 'react';
const h = React.createElement;

export interface SpinProps {
  size?: 'small' | 'default' | 'large';
  children?: React.ReactNode;
}

const Spin: React.FC<SpinProps> = function Spin(props) {
  const { size = 'default', children } = props;
  const sizeMap: Record<'small' | 'default' | 'large', string> = {
    small: 'h-4 w-4',
    default: 'h-6 w-6',
    large: 'h-8 w-8',
  };

  const spinner = h(
    'svg',
    {
      className: `animate-spin ${sizeMap[size] ?? sizeMap.default} text-primary-500`,
      fill: 'none',
      viewBox: '0 0 24 24',
    },
    h('circle', {
      className: 'opacity-25',
      cx: '12',
      cy: '12',
      r: '10',
      stroke: 'currentColor',
      strokeWidth: '4',
    }),
    h('path', {
      className: 'opacity-75',
      fill: 'currentColor',
      d: 'M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z',
    }),
  );

  if (children) {
    return h(
      'div',
      { className: 'relative' },
      h(
        'div',
        { className: 'absolute inset-0 flex items-center justify-center bg-dark-900/50 z-10' },
        spinner,
      ),
      children,
    );
  }
  return spinner;
};

export { Spin };
